import { render, staticRenderFns } from "./ListCalenderMatter.vue?vue&type=template&id=60df25f8&scoped=true"
import script from "./ListCalenderMatter.vue?vue&type=script&lang=js"
export * from "./ListCalenderMatter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60df25f8",
  null
  
)

export default component.exports